import type { ReferenceTier } from '@/lib/apollo/query/get-applicant'
export { referenceTierStylesMap } from '@/utils/tier'

export const sidebarContentMap: Record<ReferenceTier, JSX.Element | string> = {
  essential: (
    <div>
      <p>Essential only includes a Credit and ID check.</p>
      <p>
        Both of these checks are automated and can be completed as soon as we have
        completed them.
      </p>
    </div>
  ),
  advanced: (
    <div>
      <p>No calls to be placed.</p>
      <p>Closing on documents/Open Banking can happen as soon as we have them.</p>
    </div>
  ),
  advancedPlus: (
    <div>
      <p>Calls to be placed from day 2 of the chase cycle to both referee & applicant.</p>
      <p>
        Closing on documents/Open Banking need to wait for Day 3 (with the exception of
        savings/benefits/pension that can be closed on day 1).
      </p>
    </div>
  ),
  priority: (
    <div>
      <h6>AM</h6>
      <p>
        If we have docs or OB and can complete, call agent to confirm if they are happy.
      </p>
      <p>
        If no docs call to be placed to referee if not able to obtain verbal ref, call
        must be placed to applicant to request
      </p>
      <h6>PM</h6>
      <p>Reference received since AM chase complete.</p>
      <p>
        We have received new docs or OB and can complete, call agent to confirm if they
        are happy.
      </p>
      <p>
        We have not received any Docs, OB or reference from referee call applicant to
        chase & call and update the agent.
      </p>
    </div>
  ),
  hybrid: (
    <div>
      <p>
        On Advanced Hybrid, the team will place outbound calls to the referee/applicant
        from DAY 1 (If we work on in day items please call on day 0).
      </p>
      <p>
        On Advanced Hybrid, we will close on documents/Open Banking as soon as this is
        available from Day 1- we do not need to wait for Day 3 as we would do on Advanced
        Plus.
      </p>
    </div>
  ),
  pro: (
    <div>
      <p>
        On Advanced Pro, the team will place outbound calls to the referee/applicant from
        DAY 1 (If we work on in day items please call on day 0).
      </p>
      <p>
        On Advanced Pro, we will close on documents/Open Banking as soon as this is
        available from Day 1- we do not need to wait for Day 3 as we would do on Advanced
        Plus.
      </p>
    </div>
  ),
  corporate: (
    <div>
      <p>Corporate lets reference tier. Content to follow.</p>
    </div>
  ),
  dataCollection: (
    <div>
      <p>Data Collection lets reference tier.</p>
    </div>
  ),
  selfServe: (
    <div>
      <p>Data Collection lets reference tier.</p>
    </div>
  ),
  selfServeStudent: (
    <div>
      <p>
        This is a self-serve Student reference. Student references do not include income
        or credit checks.
      </p>
    </div>
  ),
}
